import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { DASHBOARD_ROUTE } from '@app/routes';

@Injectable()
export class DevOnlyGuard implements CanActivate {
  public constructor(private router: Router) {}

  public canActivate(): boolean {
    if (environment.production) {
      this.router.navigate([DASHBOARD_ROUTE]);

      return false;
    }

    return true;
  }
}
